import { makeLazyComponent } from '../../../../utils/lazy';
import './index.scss';

export const BadgeDesignerSettings = makeLazyComponent(
  async () =>
    (await import(/* webpackChunkName: "badge-designer" */ './designerrouter'))
      .BadgeDesignerSettings,
);
